<template>
  <div id="app">
    <b-spinner label="Spinning"></b-spinner>
    <div class="mt-2">Bitte warten</div>
  </div>
</template>

<script>

export default {
  name: 'AppLoading',
}
</script>

<style scoped>
#app {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
